import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { getInfo } from "../../worker-panel/slice/workerInfoSlice";
import { useSelector, useDispatch } from "react-redux";
import { logout, selectWorkerAuth } from "../../worker-auth/slice/workerAuthSlice";

const WorkerNavbar = () => {
  const token = localStorage.getItem("token");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const isWorkerLoggedIn = useSelector(selectWorkerAuth) || !!token;
  const [isOpen, setIsOpen] = useState(false);

  const workerIsVerified = useSelector(
    (state) => state.workerInfo.userData?.is_verify
  );

  const { userData } = useSelector((state) => state.workerInfo);

  const ProfileImage = useSelector(
    (state) => state.workerInfo.userData?.profile
  );

  useEffect(() => {
    if (!token) return;
    dispatch(getInfo(token));
  }, [token, dispatch]);

  const userImageUrl = ProfileImage
    ? `${process.env.REACT_APP_PROFILE_IMAGE_BACKEND_URL}/${ProfileImage}`
    : "/assets/images/default-profile-account.jpg";

  const handleWorkerLogout = () => {
    dispatch(logout());
    navigate("/signin");
  };

  return (
    <nav className="navbar navbar-expand-lg py-2 py-lg-0 navbar-bottom-shadow">
      <div className="container position-relative px-3 px-lg-1 d-flex justify-content-between align-items-center">

        {/* LOGO */}
        <div className="logo d-none d-lg-block">
          <a className="navbar-brand" href={process.env.REACT_APP_HOME_URL}>
            <img src="/assets/images/NCAF_Logo_new.png" style={{ width: "180px" }} />
          </a>
        </div>

        <div className="d-block d-lg-none">
          <a className="navbar-brand" href={process.env.REACT_APP_HOME_URL}>
            <img src="/assets/images/NCAF_Logo_new.png" style={{ width: "140px" }} />
          </a>
        </div>

        {/* TOGGLER */}
        <button
          className="navbar-toggler p-0"
          onClick={() => setIsOpen(!isOpen)}
        >
          {isOpen ? (
            <i className="fa fa-times text-white" style={{ fontSize: "22px" }}></i>
          ) : (
            <img
              src="/assets/images/menu-arrow.png"
              className="img-fluid"
              style={{ position: "relative", top: "-2px" }}
            />
          )}
        </button>

        <div className={`collapse navbar-collapse ${isOpen ? "show" : ""}`} id="navbarCollapse">

          {/* NAV LINKS */}
          <ul className="navbar-nav ms-auto mb-lg-0 align-items-lg-center me-2">

            <li className="nav-item">
              <Link className="nav-link text-white ps-0" to={process.env.REACT_APP_NCAF_NETWORKS}>NCAF Network</Link>
            </li>

            <li className="nav-item">
              <Link className="nav-link text-white ps-0" to={process.env.REACT_APP_WORKFORCE_ONBOARDING}>Workforce Onboarding</Link>
            </li>

            <li className="nav-item">
              <Link className="nav-link text-white ps-0" to={process.env.REACT_APP_BENEFITS_STABILITY}>Benefits Stability</Link>
            </li>

            <li className="nav-item">
              <Link className="nav-link text-white ps-0" to={process.env.REACT_APP_ABOUT_US}>About NCAF</Link>
            </li>

            <li className="nav-item">
              <Link className="nav-link text-white ps-0" to={process.env.REACT_APP_RESOURCES}>Resources</Link>
            </li>

            {isWorkerLoggedIn && workerIsVerified === 0 && (
              <li className="nav-item">
                <Link className="nav-link text-white" to="/panel/verify">
                  ID Verification
                </Link>
              </li>
            )}
          </ul>

          {/* ================= DESKTOP AUTH ================= */}
          <div className="d-none d-lg-flex log-in">
            {isWorkerLoggedIn ? (
              <div className="d-flex align-items-center gap-2">
                <h4 className="text-white mb-0">
                  {userData?.first_name || "Guest"}
                </h4>

                <img
                  src={userImageUrl}
                  alt="Profile"
                  style={{ height: 35, width: 35, borderRadius: 8 }}
                />

                <button
                  className="btn btn-outline-light-login"
                  onClick={handleWorkerLogout}
                >
                  Logout
                  <i className="fa fa-sign-out ms-2" aria-hidden="true"></i>
                </button>
              </div>
            ) : (
              <div className="d-flex align-items-center gap-2">

                <div className="dropdown">
                  <button className="btn btn-outline-light-login font-weight-medium rounded"
                    data-bs-toggle="dropdown" id="loginDropdown">
                    <span className="d-block py-1 px-2">Register <i className="ms-1 fa fa-caret-down" aria-hidden="true"></i></span>
                  </button>

                  <ul className="dropdown-menu">
                    <li><Link className="dropdown-item" to={process.env.REACT_APP_EMPLOYER_SIGNUP}>Provider Registration</Link></li>
                    {/* <li><Link className="dropdown-item" to={process.env.REACT_APP_WORKER_SIGNUP}>Teacher/Staff Registration</Link></li>
                    <li><Link className="dropdown-item" to={process.env.REACT_APP_Volunteer_SIGNUP}>Volunteer Registration</Link></li> */}
                  </ul>
                </div>

                <Link to="/signin">
                  <button className="btn btn-outline-light text-white font-weight-medium rounded"><span className="d-block py-1 px-2">Sign In</span></button>
                </Link>
                <Link to={process.env.REACT_APP_PARTICIPATION_PAGE}>
                  <button className="btn btn-outline-light-donation text-white font-weight-medium rounded ms-2"><span className="d-block py-1 px-2" >Join NCAF</span></button>
                </Link>
              </div>
            )}
          </div>

          {/* ================= MOBILE AUTH (SEPARATE SECTION) ================= */}
          {/* ================= MOBILE AUTH (LI STYLE) ================= */}
          <div className="d-block d-lg-none me-2">

            <ul className="navbar-nav">

              {!isWorkerLoggedIn ? (
                <>
                  <li className="nav-item dropdown">
                    <button
                      type="button"
                      className="nav-link text-white ps-0 bg-transparent border-0 dropdown-toggle"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                      style={{ height: "40px" }}
                    >
                      Register
                    </button>

                    <ul className="dropdown-menu custom-dropdown">
                      <li className="custom-dropdown-li">
                        <Link className="dropdown-item" to={process.env.REACT_APP_EMPLOYER_SIGNUP}>
                          Provider Registration
                        </Link>
                      </li>

                      {/* <li className="custom-dropdown-li">
                        <Link className="dropdown-item" to={process.env.REACT_APP_WORKER_SIGNUP}>
                          Teacher/Staff Registration
                        </Link>
                      </li>

                      <li className="custom-dropdown-li">
                        <Link className="dropdown-item" to={process.env.REACT_APP_Volunteer_SIGNUP}>
                          Volunteer Registration
                        </Link>
                      </li> */}
                    </ul>
                  </li>

                  <li className="nav-item">
                    <Link className="nav-link text-white ps-0" to="/signin">
                      Sign In
                    </Link>
                  </li>

                  <li className="nav-item">
                    <Link className="nav-link text-white ps-0" to={process.env.REACT_APP_PARTICIPATION_PAGE}>
                      Join NCAF
                    </Link>
                  </li>
                </>
              ) : (
                <>
                  {/* <li className="nav-item">
                    <span className="nav-link text-white ps-0">
                      {userData?.first_name || "Guest"}
                    </span>
                  </li> */}

                  <li className="nav-item">
                    <button
                      className="nav-link text-white bg-transparent border-0 ps-0"
                      onClick={handleWorkerLogout}
                    >
                      Logout
                      <i className="fa fa-sign-out ms-2" aria-hidden="true"></i>
                    </button>
                  </li>
                </>
              )}

            </ul>

          </div>

        </div>
      </div>
    </nav>
  );
};

export default WorkerNavbar;